import { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import classes from './Discovery.module.css'
import useBotsService from '../../../../services/bot/botService';
import { useBotConfig } from '../../../../context/BotConfigContext';
import DiscoveryButtons from './discoveryButtons/DiscoveryButtons';

function Discovery({ showButtons = true, buttons, onButtonClick }) {
  const config = useBotConfig();
  const greeting = config?.botSubTitle;
  const { texts } = useSelector((state) => state.translate);
  const chipButtons = Array.isArray(buttons) ? buttons : [];

  return (
    <div className={classes.Discovery}>
      <img src={config?.botIconUrl} alt="" />
      <div className={classes.Title}>
        {config?.botTitle}
      </div>
      <div className={classes.Subtitle}>
        {greeting}
      </div>
      {showButtons ? (
        <DiscoveryButtons buttons={chipButtons} onButtonClick={onButtonClick} />
      ) : null}
    </div>
  );
}

export default Discovery;
